import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CheckradioComponent } from './checkradio.component';

@NgModule({
  declarations: [CheckradioComponent],
  imports: [CommonModule, FormsModule, ReactiveFormsModule],
  exports: [CheckradioComponent],
})
export class CheckRadioModule {}
